import { mapState, mapActions, mapMutations } from "vuex";
import { steps, components } from "./stepper";
export default {
    components: { ...components },

    data() {
        return {
            loading: false,
            steps,
            showStepErrorNotice: false
        };
    },

    computed: {
        stepIndex: {
            get() {
                return this.$store.getters.currentStep.index;
            },
            set(value) {
                this.setStepByIndex(value);
            },
        },
        step: {
            get() {
                return this.$store.state.step;
            },
            set(step) {
                this.commit("SET", { step });
            },
        },
        currentStep() {
            return this.$store.getters.currentStep;
        },
        forwardBtnDisabled() {
            return this.$store.getters.forwardBtnDisabled;
        },
        currentStepHasVisibleErrors() {
            return this.$store.getters['stepHasVisibleErrors'](this.$store.state.step)
        }
    },

    watch: {
        step: {
            immediate: true,
            handler() {
                this.setStepsThatShouldBeValidated()
            }
        },

        currentStepHasVisibleErrors(currentStepHasVisibleErrors) {
            if (!currentStepHasVisibleErrors) this.showStepErrorNotice = false
        }

    },

    methods: {
        ...mapMutations(["SET"]),
        ...mapActions(["setStepByIndex", "nextStep"]),

        previous() {
            this.$store.dispatch("previousStep", this);
        },

        next(checkValidityOfCurrentStep = true) {
            if (checkValidityOfCurrentStep && !this.showStepErrorNotice) {
                this.addCurrentStepToStepsThatShouldBeValidated();

                if (this.$store.getters['stepHasErrors'](this.$store.state.step)) {
                    this.showStepErrorNotice = true;
                    return;
                }
            } else {
                this.showStepErrorNotice = false
            }

            this.$store.dispatch("nextStep", this);
        },

        setStepsThatShouldBeValidated() {
            const currentStep = this.currentStep.component
            const shouldValidateSteps = this._.cloneDeep(this.$store.state.shouldValidateSteps)

            for (const step of steps) {
                if (step.component === currentStep) {
                    this.$store.commit('SET', { shouldValidateSteps })
                    return
                };

                if (!shouldValidateSteps.includes(step.component))
                    shouldValidateSteps.push(step.component)
            }
        },

        addCurrentStepToStepsThatShouldBeValidated() {
            if (!this.$store.state.shouldValidateSteps.includes(this.step)) {
                const shouldValidateSteps = this._.cloneDeep(this.$store.state.shouldValidateSteps)
                shouldValidateSteps.push(this.step);
                this.$store.commit('SET', { shouldValidateSteps });
            }
        },

        stepRules(step) {
            let hasErrors = false

            if (
                this.$store.state.shouldValidateSteps.includes(step) &&
                this.$store.getters['stepHasErrors'](step)
            ) {
                hasErrors = true
            }

            return [() => !hasErrors]
        }
    },
};
